import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import AvatarModal from 'components/AvatarModal';

import { getUserPhotoURL } from 'utils';

import { ModalContainer } from './UserSetup.styled';

const UserSetup = ({ currentUser, updateProfile }) => {
  const [name, setName] = useState('');
  const [avatar, setAvatar] = useState('avatar-0');
  const [showAvatars, setShowAvatars] = useState(false);

  const nameChangeHandler = useCallback((e) => {
    setName(e.target.value);
  }, []);

  const submitHandler = useCallback(
    (e) => {
      e.preventDefault();

      if (name && name.length > 0 && avatar.length > 0)
        updateProfile({
          uid: currentUser.uid,
          displayName: name,
          photoURL: avatar,
        });
    },
    [avatar, currentUser, name, updateProfile],
  );

  const toggleAvatarModal = useCallback(() => {
    setShowAvatars((state) => !state);
  }, []);

  const changeAvatar = useCallback((value) => {
    setAvatar((state) => (state !== value ? value : state));
  }, []);

  useEffect(() => {
    setName(currentUser.displayName || '');
    setAvatar(currentUser.photoURL || 'avatar-0');
  }, [currentUser]);

  return (
    <>
      <ModalContainer className="absolute-inset">
        <div>
          <h2 className="center">
            You&apos;re
            <br />
            almost done
          </h2>
          <form className="users-form" onSubmit={submitHandler}>
            <div className="center">
              <img
                src={getUserPhotoURL(avatar)}
                alt="avatar"
                height="88px"
                width="88px"
              />
            </div>
            <Button type="button" styled grey fluid onClick={toggleAvatarModal}>
              Choose different avatar
            </Button>
            <label htmlFor="displayName">
              Display Name
              <input
                type="text"
                name="displayName"
                id="displayName"
                value={name}
                onChange={nameChangeHandler}
                placeholder="Enter your name"
                required
              />
            </label>
            <Button
              type="submit"
              fluid
              disabled={
                (name && name.length === 0) || (avatar && avatar.length === 0)
              }>
              Finish
            </Button>
          </form>
        </div>
      </ModalContainer>
      {showAvatars && (
        <AvatarModal
          toggleAvatarModal={toggleAvatarModal}
          onSubmit={toggleAvatarModal}
          currentAvatar={avatar}
          changeAvatar={changeAvatar}
        />
      )}
    </>
  );
};

UserSetup.propTypes = {
  currentUser: PropTypes.object.isRequired,
  updateProfile: PropTypes.func.isRequired,
};

export default UserSetup;
